import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Text, VStack } from '@chakra-ui/react'
import { useShareVehicle, useVehicles } from 'context'
import { CONTACT_SHARE_VEHICLE_SCHEMA, ShareVehicleAddContactType } from 'context/ShareVehicle'
import { Formik } from 'formik'
import { primaryColor } from 'theme/foundations/primaryColor'

import { CardBody, CardContainer } from 'components/CustomCard'
import { InputControl, SubmitButton } from 'components/InputCustom'
import { MailIcon } from 'components/SVGS'
import { customToast } from 'components/ToastCustom'

export const AddContactShareVehicle = () => {

  const navigate = useNavigate()
  const { text: { bgColorText } } = primaryColor

  const { shareVehicleState: { state: { contactsShareVehicles } } } = useShareVehicle()
  const { vehicleState: { state: { vehicle } } } = useVehicles()

  const initialValues: ShareVehicleAddContactType = {
    emailInvited: '',
    idVehicle: vehicle?.id ?? '',
    isRestricted: null
  }

  const handleOnSubmit = async (values: ShareVehicleAddContactType) => {
    const { emailInvited, idVehicle } = values

    if (contactsShareVehicles.some(contact => contact.email.toLowerCase() === emailInvited.toLowerCase()))
      return customToast.showToast({
        description: 'El correo que ingresaste ya se encuentra en tu lista de invitados, por favor ingresa otro correo',
      })

    else if (vehicle?.isPremium)
      navigate('/request-permissions-share-vehicle',
        { state: { params: { emailInvited, idVehicle, previousRoute: 'ADD' } } })
  }

  const handleGoBack = useCallback(() => {
    !vehicle && navigate('/my-vehicles')
  }, [vehicle, navigate])

  useEffect(() => {
    handleGoBack()
  }, [handleGoBack])

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={CONTACT_SHARE_VEHICLE_SCHEMA}>
      <CardContainer
        isScreen
        hiddenStack={false}
        onClose={handleGoBack}
        headerText={'Compartir vehículo '}>
        <CardBody>
          <VStack justifyContent={'center'} alignItems={'center'} spacing={6}>
            <VStack>
              <MailIcon size={'60px'} fill={bgColorText} />
            </VStack>
            <VStack>
              <Text variant={'H2'} textAlign='center'>
                Ingresa un correo
              </Text>
            </VStack>
            <VStack>
              <Text variant={'SM'}>
                Para compartir tu vehículo ingresa el correo del invitado
              </Text>
            </VStack>
            <InputControl
              inputProps={{ placeholder: 'Ingresar correo electrónico' }}
              name='emailInvited'
              label='Correo electrónico'
            />
            <SubmitButton
              mx={'auto'}
              w={'full'}
            >
              Siguiente
            </SubmitButton>
          </VStack>
        </CardBody>
      </CardContainer>
    </Formik >
  )
}
